import { jsx, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Anchor } from '@mirohq-internal/website-ui-foundation';

const LegalHub = ({ legalHubLinks })=>{
    return jsx(Fragment, {
        children: legalHubLinks.map((link)=>{
            return jsx(Anchor, {
                href: link.href,
                className: classNames('text-tertiary'),
                children: jsx("span", {
                    className: "d-block text-wrap text-center",
                    children: link.title
                })
            }, link.href);
        })
    });
};

export { LegalHub };
